var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-slide"},[_vm._m(0),_c('p',{staticClass:"title",on:{"click":_vm.addSlide}},[_vm._v("Add Slide")]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-rule"},[_c('hr',{attrs:{"width":"100%","height":"0.1rem"}})])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal-rule"},[_c('hr',{attrs:{"width":"100%","height":"0.1rem"}})])
}]

export { render, staticRenderFns }